import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getSelectSectors } from "@/Api/sectors";
import { getSelectPositions } from "@/Api/positions";
import type { UnityFilterState } from "@/components/UnityFilter";

type Option = { id: number | string; name: string };

const ALL = "all";

const FilterSelect = ({
  label,
  placeholder,
  value,
  options,
  onChange,
}: {
  label: string;
  placeholder: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
}) => (
  <div className="space-y-1.5 w-full sm:w-60">
    <Label className="text-sm">{label}</Label>
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? "" : v)}>
      <SelectTrigger className="h-9 w-full">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{placeholder}</SelectItem>
        {options.map((option) => (
          <SelectItem key={option.id} value={String(option.id)}>
            {option.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

/** Filtros de setor e cargo — as listas acompanham a(s) unidade(s) escolhida(s). */
export const EmployeesExtraFilters = ({ filter }: { filter: UnityFilterState }) => {
  const { extra, setExtra, selected } = filter;
  const [sectors, setSectors] = useState<Option[]>([]);
  const [positions, setPositions] = useState<Option[]>([]);
  const unityKey = selected.join(",");

  useEffect(() => {
    setExtra("sector_id", "");
    setExtra("position_id", "");
    (async () => {
      const [{ data: sectorsData }, { data: positionsData }] = await Promise.all([
        getSelectSectors(unityKey || undefined),
        getSelectPositions(unityKey || undefined),
      ]);
      setSectors(sectorsData?.response ?? []);
      setPositions(positionsData?.response ?? []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unityKey]);

  // Cargo pertence a um setor: escolher o setor restringe os cargos.
  useEffect(() => {
    setExtra("position_id", "");
    (async () => {
      const { data } = await getSelectPositions(
        unityKey || undefined,
        extra.sector_id || undefined
      );
      setPositions(data?.response ?? []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extra.sector_id]);

  return (
    <>
      <FilterSelect
        label="Setor"
        placeholder="Todos os setores"
        value={extra.sector_id || ""}
        options={sectors}
        onChange={(v) => setExtra("sector_id", v)}
      />
      <FilterSelect
        label="Cargo"
        placeholder="Todos os cargos"
        value={extra.position_id || ""}
        options={positions}
        onChange={(v) => setExtra("position_id", v)}
      />
    </>
  );
};
